import create from 'zustand';
import produce from 'immer';
import { take } from 'lodash';

import DayJs from 'utils/Dayjs';

const STUDENT_WEBINAR_INITIAL = {
	months: [],
	active: []
};

export const useStudentWebinarStore = create(set => ({
	...STUDENT_WEBINAR_INITIAL,

	// Initialize student's webinar state
	onInit: (webinars) => set(produce(state => {
		// Get today's date
		const today = DayJs().subtract(2, 'hour');

		// Get study months
		const months = webinars?.reduce((segments, webinar) => {
			const month = DayJs(webinar.eventAt).format('MMMM');
			if (segments.includes(month)) return segments;
			return [...segments, month];
		}, []);

		// Map webinars by month
		state.months = months?.map(month => ({
			title: month,
			webinars: webinars?.filter(w => DayJs(w.eventAt).format('MMMM') === month)
		}));

		// Filter out 4 webinars, that will be soon
		state.active = take(webinars?.filter(webinar => {
			return DayJs(webinar.eventAt).isAfter(today);
		}), 4);
	})),

	// Reset store to initial state
	onReset: () => set({
		...STUDENT_WEBINAR_INITIAL
	})
}));